import { buildPublicCDNUrl } from "@repo/utils/lib/url";
import type {
  IImageTransformationsProvider,
  ImageTransformationKind,
  SupportedImageTransformationsProvider,
} from "../../../types";

export class NoneProvider implements IImageTransformationsProvider {
  identifier: SupportedImageTransformationsProvider = "none";

  buildImageCDNUrl(key: string, _kind?: ImageTransformationKind): string {
    return buildPublicCDNUrl(key);
  }

  convertToTransformationUrl(
    current: string,
    _kind?: ImageTransformationKind,
  ): string {
    return current;
  }

  isTransformationUrl(_url: string): boolean {
    return false;
  }
}

export const noneProvider = new NoneProvider();
